import LintasAPIService from '../../APIServices/lintasapi';
import { showToast } from '../../Utils';
import { userTypes } from '../../Utils/constants';
import {
  SHOW_USER_FORM, DASH_USER_CREATED, GET_DASH_USERS, GET_ALL_DASH_USERS, ASSIGN_PRODUCT_DASH,
  UPDATE_ASSIGN_PRODUCTS,
  REMOVE_ASSIGN_PRODUCT,
  REMOVE_ASSIGN_PRODUCT_FROM_COMMON,
  UPDATE_DASH_USER,
  UPDATE_PRODUCT_USERS,
  GET_DASH_BUYERS,
  DASH_BUYER_CREATED,
  UPDATE_DASH_BUYERS,
} from '../actionTypes';
import { handleErrorLocal, loader } from './common';
import { updateDashSuppliers } from './suppliers';

const apiCall = new LintasAPIService();

export const showUserForm = (val) => (dispatch) => {
  dispatch({
    type: SHOW_USER_FORM,
    payload: val,
  })
}

export const createDashUser = (data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .createDashUser({ data })
    .then((response) => {
      dispatch(loader(false))
      showToast('success', 'User created successfully!!');
      switch (data.userType) {
        case `${userTypes.manager}`:
        case `${userTypes.creative}`:
          dispatch({
            type: DASH_USER_CREATED,
            payload: response.data,
          })
          break;
        case `${userTypes.buyer}`:
          dispatch({
            type: DASH_BUYER_CREATED,
            payload: response.data,
          })
          break;
        default:
          break;
      }
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const getDashUsers = (page = 0) => (dispatch) => {
  const data = { page, userType: userTypes.manager }
  apiCall
    .getDashUsers(data)
    .then((response) => dispatch({
      type: GET_DASH_USERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const getAllDashUsers = (page = 0) => (dispatch) => {
  apiCall
    .getAllDashUsers({ page })
    .then((response) => dispatch({
      type: GET_ALL_DASH_USERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const assignProduct = (data) => (dispatch) => {
  apiCall
    .assignProduct(data)
    .then((response) => {
      showToast('success', response.data.message);
      dispatch({
        type: ASSIGN_PRODUCT_DASH,
        payload: response.data,
        userId: data.dashUserId,
      })
      dispatch({
        type: UPDATE_ASSIGN_PRODUCTS,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const removeAssingedProduct = (userId, productId, location = 1) => (dispatch) => {
  apiCall
    .removeAssingedProduct(userId, productId)
    .then((response) => {
      showToast('success', response.data.message);
      if (location === 1) {
        dispatch({
          type: REMOVE_ASSIGN_PRODUCT,
          payload: userId,
          productId,
        })
      } else {
        dispatch({
          type: REMOVE_ASSIGN_PRODUCT_FROM_COMMON,
          payload: userId,
          productId,
        })
      }
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const updateDashUser = (data, id, userType) => (dispatch) => {
  apiCall
    .updateDashUser(data, id)
    .then((response) => {
      showToast('success', response.data.message);
      switch (userType) {
        case 'manager':
          dispatch({
            type: UPDATE_DASH_USER,
            payload: response.data.data,
          })
          break;
        case 'supplier':
          updateDashSuppliers(response.data.data)
          break;
        case 'buyer':
          dispatch({
            type: UPDATE_DASH_BUYERS,
            payload: response.data.data,
          })
          break;
        default:
          break;
      }
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const getProductUsers = (productId) => (dispatch) => {
  apiCall
    .getProductUsers(productId)
    .then((response) => dispatch({
      type: UPDATE_PRODUCT_USERS,
      payload: response.data,
      productId,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const getBuyers = (page = 0, stateName = null) => (dispatch) => {
  const data = { page, userType: userTypes.buyer }
  if (stateName) {
    data.dependedValue = stateName
  }
  apiCall
    .getDashUsers(data)
    .then((response) => dispatch({
      type: GET_DASH_BUYERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}
